/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Space, Col, Row } from 'antd';

import { FULL_WIDTH } from '@constants';
import { FormFieldEmulation } from '@atoms';
import { DATE_OPTION, DATE_OPTIONS, MAP_DATE_OPTION_TO_API } from '@api/articles/constants';
import { Form } from '@organisms';

import ArticleSelect from '../ArticleSelect';
import TableSelect from '../TableSelect';
import EventSelect from '../EventSelect';

import s from './styles.module.less';

const ArticlesByEventField = ({ isTypeFilter, ...props }) => {
  const [event, setEvent] = React.useState();
  const [dateFilter, setDateFilter] = React.useState();

  return (
    <Form.WithFieldValue name={props.name}>
      {(_, { setFieldsValue }) => (
        <Space size={0} direction="vertical" style={FULL_WIDTH}>
          <FormFieldEmulation label="for" wrapperCol={16} className={s.row}>
            <EventSelect
              style={FULL_WIDTH}
              onChange={(value) => {
                setEvent(value);
                setFieldsValue({ [props.name]: undefined });
              }}
            />
          </FormFieldEmulation>
          <FormFieldEmulation label="posted" wrapperCol={12} className={s.row}>
            <TableSelect
              style={FULL_WIDTH}
              options={DATE_OPTIONS}
              defaultValue={DATE_OPTION.ALL.key}
              onChange={(value) => {
                setDateFilter(value);
                setFieldsValue({ [props.name]: undefined });
              }}
            />
          </FormFieldEmulation>
          <Row>
            <Col span={21} offset={3}>
              <Form.Item {...props}>
                <ArticleSelect
                  style={FULL_WIDTH}
                  queryVariables={{ eventId: event?.id, ...MAP_DATE_OPTION_TO_API[dateFilter] }}
                  isTypeFilter
                />
              </Form.Item>
            </Col>
          </Row>
        </Space>
      )}
    </Form.WithFieldValue>
  );
};

export default ArticlesByEventField;
